import { NgModule } from '@angular/core';
import { ConnectedPageComponent } from './components/connected-page/connected-page.component';
import { MentionsLegalesComponent } from './components/mentions-legales/mentions-legales.component';
import { GS1ButtonModule, GS1FormModule, GS1LayoutModule, GS1LoaderModule } from '@gs1france/gs1-components-library';
import { SinglePageComponent } from './components/single-page/single-page.component';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CGUDialogComponent } from './components/cgu/cgu.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PhonePipe } from './pipe/phone.pipe';
import { DisconnectedDialogComponent } from './components/disconnected-dialog/disconnected-dialog.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { NonPayerDialogComponent } from './components/non-payer/nonpayer-dialog.component';
import { GlnPopinComponent } from './components/gln-popin/gln-popin.component';

/**
 * The CoreModule is the main module for the GLN app.
 * It contains all the components and directives that are used across the app.
 * @module CoreModule
 */
@NgModule({
    declarations: [
        ConnectedPageComponent, MentionsLegalesComponent, SinglePageComponent, CGUDialogComponent, PhonePipe, DisconnectedDialogComponent, NonPayerDialogComponent,GlnPopinComponent
    ],
    exports: [
        ConnectedPageComponent, SinglePageComponent, CGUDialogComponent
    ],
    imports: [
        GS1ButtonModule, RouterModule, CommonModule, GS1FormModule, MatTooltipModule, GS1LoaderModule,
        ReactiveFormsModule, NgSelectModule, FormsModule, MatDialogModule, GS1LayoutModule
        , GoogleMapsModule
    ]
})
export class CoreModule { }
